import { Directive } from '@angular/core';

@Directive({
  selector: '[appModalContainerStyles]',
  host: {
    class:
      'px-12 py-6 w-[580px] max-w-[95vw] bg-white rounded-lg min-h-[400px]',
  },
})
export class ModalContainerStylesDirective {}
